<template>
    <div class="service-page-qiangzhi-buxudong">
        <div class="shop-header-margin shop-header-element-ui-less"
             :class="'shop-header-element-ui-less-'+data_info.nav_color">
            <div class="top-one">
                <lig_head></lig_head>
            </div>
            <div class="top-two hidden-sm-and-down">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                        <div>
                            <el-row :gutter="20">
                                <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7">
                                    <img src="../../../assets/home/logo.png"
                                         style="width: 100%;height: 100%"/>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                    <div class="top-two_text">
                                        <span style="float: left">{{data_info.shop_name}}</span>
                                        <div class="follow" style="color: #c60000;border: 1px solid #c60000;">
                                            <span v-if="data_info.auth_info.type==1">个人</span>
                                            <span v-if="data_info.auth_info.type==2">企业</span>
                                            <span v-if="data_info.auth_info.type==3">企业</span>
                                        </div>
                                        <div class="follow" :class="data_info.nav_color+'_follow'" @click="shouce1()">
                                            {{xiontai}}
                                        </div>
                                    </div>
                                    <div class="label">技能标签：
                                        <el-tag type="info" style="margin-right: 5px;" size="mini"
                                                v-for="(item,index) in data_info.skill" :key="index">{{ item.tag_value
                                            }}
                                        </el-tag>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="20" :md="9" :lg="9" :xl="9">
                        <div>
                            <el-input size="small " placeholder="请输入内容" v-model="input3" class="input-with-select">
                                <el-select class="xujz" v-model="select" slot="prepend" placeholder="请选择">
                                    <el-option v-if="data_info.auth_info.type!==1" label="在线商品"></el-option>
                                    <el-option label="在线服务" value="#/shops/service/"></el-option>
                                    <el-option label="成功案例" value="#/shops/case/"></el-option>
                                    <el-option label="仪才秀" value="#/shops/video/"></el-option>
                                    <el-option label="小星点灯" value="#/shops/light/"></el-option>
                                    <el-option label="应用方案" value="#/shops/programme/"></el-option>
                                    <el-option label="行业标准" value="#/shops/standard/"></el-option>
                                </el-select>
                                <el-button slot="append" @click="shijian">搜索</el-button>
                            </el-input>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="top-three hidden-sm-and-down" :class="data_info.nav_color">
                <div class="hidden-sm-and-down three_pc">
                    <a :href="'#/shops/index/'+id">
                        <div class="kuai " :class="$route.path==='/shops/index/'+id?data_info.nav_color+'_new':''">首页
                        </div>
                    </a>
                    <a :href="'#/shops/commodity/'+id" v-if="data_info.auth_info.type!==1">
                        <div class="kuai" :class="$route.path=='/shops/commodity/'+id?data_info.nav_color+'_new':''">
                            在线商品
                        </div>
                    </a>
                    <a :href="'#/shops/service/'+id">
                        <div class="kuai" :class="$route.path=='/shops/service/'+id?data_info.nav_color+'_new':''">在线服务
                        </div>
                    </a>
                    <a :href="'#/shops/case/'+id">
                        <div class="kuai" :class="$route.path=='/shops/case/'+id?data_info.nav_color+'_new':''">成功案例
                        </div>
                    </a>
                    <a :href="'#/shops/video/'+id">
                        <div class="kuai" :class="$route.path=='/shops/video/'+id?data_info.nav_color+'_new':''">仪才秀
                        </div>
                    </a>
                    <a :href="'#/shops/light/'+id">
                        <div class="kuai1" :class="$route.path=='/shops/light/'+id?data_info.nav_color+'_new':''">小星点灯
                        </div>
                    </a>
                    <a :href="'#/shops/programme/'+id">
                        <div class="kuai" :class="$route.path=='/shops/programme/'+id?data_info.nav_color+'_new':''">
                            应用方案
                        </div>
                    </a>
                    <a :href="'#/shops/standard/'+id">
                        <div class="kuai" :class="$route.path=='/shops/standard/'+id?data_info.nav_color+'_new':''">行业标准
                        </div>
                    </a>
                    <a :href="'#/shops/companyData/'+id">
                        <div class="kuai" :class="$route.path=='/shops/companyData/'+id?data_info.nav_color+'_new':''">
                            公司资料
                        </div>
                    </a>
                </div>
            </div>
            <el-main class="service-main">
                <div style="width: 100%;padding: 50px 30px;background: #FFFFFF;margin-bottom: 50px;">
                    <div style="font-size: 22px;">{{casezhi.title}}</div>
                    <div id="html-content" v-html="wenzhang_neirong"></div>
                    <div class="goods_details">
                        <el-row v-for="(item,index) in list" v-bind:key="index" style="float: left">
                            <el-col :title="item.title">

                                <div class="details_image">
                                    <a :href="'#/dianpu_details/'+item.id">
                                        <span class="details_name">{{item.title}}</span>
                                        <el-image :src="url+'/storage/'+item.cover"
                                                  style="width: 150px;height: 150px"></el-image>
                                    </a>
                                </div>

                            </el-col>
                        </el-row>
                    </div>
                </div>
                <!-- 商品名称和图片的展示-->

            </el-main>


        </div>
    </div>
</template>

<script>
    import head from "../../common/head";

    export default {
        name: "dianpu_ligs",
        data: function () {
            return {
                is_open: {
                    sousuo: 1,
                    lanmu: 1,
                    phone_shaixuan: 0,
                    phone_sousuokuang: 0,
                },
                data_info: '',
                id: '',
                list: '',
                url: '',
                information: '',
                input: '',
                searchValue: '',
                imforid: '',
                input3: '',
                xiontai: '',
                select: '在线服务',
                value: 5,
                wenzhang_neirong: '',
                casezhi: '',
            }
        },
        //引入组件的
        components: {
            'lig_head': head,
        },
        methods: {
            dp_inform() {
                var t = this;
                var url = window.config.api_url + '/college/shop/info?id=' + t.id
                t.axios.get(url).then(res => {
                    t.data_info = res.data
                    console.log("2323232322", res.data)
                })
            },
            list_data() {
                var t = this
                var url = window.config.api_url + '/college/light/' + t.$route.params.id
                t.axios.get(url).then(res => {
                    t.list = res.data.info.fuwu_related
                    t.casezhi = res.data.info
                    t.id = res.data.info.shop_id
                    console.log('zgqwsg', res.data)
                    t.dp_inform()

                    var html_content = res.data.info.content;
                    html_content = html_content.replace(/(<img .*?src=)"\/(.*?)"/g, '$1"' + window.config.yihai_site + '/$2"');
                    html_content = html_content.replace(/(<source .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    html_content = html_content.replace(/(<video .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    t.wenzhang_neirong = html_content;

                })

            },

            shijian() {
                var t = this
                if (t.input3) {
                    t.$store.commit('shopsSearchValue', t.input3)
                }
                window.location = t.select + this.$route.params.id
            },
            guanzhu() {
                var t = this
                var id = localStorage.getItem('token')
                var url = window.config.api_url + '/user/shop/focus/check/' + t.$route.params.id + '?token=' + id
                t.axios.get(url).then(res => {
                    // console.log(res,89444444444)
                    t.xiontai = res.data.focus == 1 ? '已关注' : '关注'
                })
            },
            shouce1() {
                // console.log(cet);
                var t = this
                var id = localStorage.getItem("uid")
                var formData = new FormData();
                formData.append('token', id);
                // formData.append('shop_id', this.$route.params.id);
                if (t.xiontai == '关注') {
                    var url = window.config.api_url + '/user/shop/focus'
                    t.axios.post(url, formData).then(res => {
                        // console.log(res)
                        t.$code(res.data.status)
                        if (res.data.status == 0) {
                            t.open2('成功')
                            // t.list_data()
                            this.$router.go(0);
                        }
                        if (res.data.status != 0) {
                            t.open3(res.data.description)
                        }
                    })
                    this.xiontai = '已关注'
                } else {
                    var url1 = window.config.api_url + '/user/shop/unfocus'
                    t.axios.post(url1, formData).then(res => {
                        // console.log(res)
                        t.$code(res.data.status)
                        if (res.data.status == 0) {
                            t.open2('成功')
                            // t.list_data()
                            this.$router.go(0);
                        }
                        if (res.data.status != 0) {
                            t.open3(res.data.description)
                        }
                    })
                    this.xiontai = '关注'
                }
            },
            sousuo_xuanxiang(e) {
                this.is_open.sousuo = e
                console.log(this.is_open.sousuo)

            },
            fujiaxz(e) {
                this.$router.push(this.url + '/storage/' + e);
            },
            init() {
                this.information = this.$store.state.information
                var t = this
                this.information = this.$store.state.information
                t.id = t.$route.params.id
                if (t.searchValue) {
                    t.input = t.searchValue
                }
                this.url = window.config.api_url
                this.list_data()
                this.guanzhu()
            },
        },
        created() {
            this.init()
        }

    }
</script>

<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
    @import "../../../assets/css/head_yangshi";
    //@head_text : Source Han Sans CN;
    @font-face {

    }

    @import "../../../assets/css/home";
    a {
        text-decoration: none !important;
    }

    .el-footer {
        background-color: #FFFFFF;
        color: #333;
        //text-align: center;
        padding: 0 0;
        //line-height: 60px;
    }

    .el-main {
        overflow: hidden;
        padding: 0;
    }

    .goods_details {
        display: inline-block;
        margin-left: -90px;
        margin-top: 30px;

    }

    .details_name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: normal;
        width: 80px;
        display: inline-block;
        position: relative;
        top: 30px;
        left: 130px;

    }

    .details_image {
        margin-bottom: 50px;

    }

    .el-header {
        background: #FFFFFF;
        padding: 0 0;

    }

    .header_pc {
        border-bottom: #4E6EF2 solid 3px;
    }


    #app {
        background: #F9F9F9;

        .head_dingbu {
            width: 100%;
            height: 38px;
            background: #F4F4F4;

            .head_width {
                width: 90%;
                max-width: 1200px;
                margin-right: auto;
                margin-left: auto;

                .head_dingwei {
                    //float: ;
                    margin-left: 5px;
                    margin-top: 13px;
                    position: absolute;
                    width: 10px;
                    height: 13px;
                }

                .head_youxiang {
                    margin-left: 34px;
                    margin-top: 13px;
                    position: absolute;
                    width: 17px;
                    height: 13px;
                }

                .head_text_cao_left {
                    margin-left: 26px;
                }

                .head_text_xiaoxi_left {
                    margin-left: 57px;
                }

                .head_text_denglu_left {
                    margin-left: 202px;
                }

                .head_text_shouye_left {
                    margin-left: 48px;
                }

                .head_text_shangjia_left {
                    margin-left: 44px;
                }

                .head_text_wode_left {
                    margin-left: 46px;
                }

                .head_text_kefu_left {
                    margin-left: 50px;
                }

                .head_text_wangzhan_left {
                    margin-left: 34px;
                }

                .header_logo_top {
                    margin-top: 32px;

                    .header_logo {
                        width: 181px;
                        height: 48px;
                        float: left;
                    }

                    .header_sousuo {

                        width: 503px;
                        height: 45px;
                        margin-top: 20px;
                        border: 3px solid #4E6EF2;
                        border-radius: 5px 0px 0px 5px;
                        //margin-left: 20%;
                        float: left;

                        .header_sousuo_logo {
                            width: 14px;
                            height: 14px;
                            margin-top: 16px;
                            margin-left: 13px;
                            margin-right: 15px;
                            float: left;
                        }

                        .header_sousuo_tuijian {
                            position: absolute;
                            margin-top: -22px;
                            font-size: 14px;
                            font-family: Source Han Sans CN;
                            font-weight: bold;
                            color: #333333;
                            float: left;
                            margin-left: 45px;
                        }

                        .header_sousuo_tuijian_2 {
                            margin-left: 125px;
                        }

                        .header_sousuo_tuijian_3 {
                            margin-left: 205px;
                        }

                        .header_sousuo_tuijian_xuanzhong {
                            padding: 5px 10px 1px 10px;
                            background: #4E6EF2;
                            margin-top: -29px;
                            color: #FFFFFF;
                            border-radius: 5px 5px 0px 0px;
                        }
                    }

                    .header_sousuo_button {
                        margin-top: 20px;
                        border: none;
                        width: 100px;
                        height: 45px;
                        background: #4E6EF2;
                        border-radius: 0px 5px 5px 0px;

                        font-size: 18px;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #FFFFFF;
                    }
                }

                .header_gongye_lianjie {
                    margin-top: 36px;

                    .header_gongye_kuang {
                        float: left;
                        width: 220px;
                        //height: 45px;
                        background: #4E6EF2;
                        border-radius: 5px 5px 0px 0px;

                        .header_gongye_kuang_text {
                            //width: 74px;
                            //height: 18px;
                            cursor: pointer;
                            float: left;
                            font-size: 18px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            margin-top: 10px;
                            margin-left: 22px;
                            //line-height: 100px;
                        }

                        .header_gongye_kuang_zhuangtai {
                            width: 40px;

                            background: #FFFFFF;
                            border-radius: 2px;
                            float: left;
                            margin-top: -2px;
                            margin-left: 36px;
                        }

                        .header_gongye_kuang_zhuangtai2 {
                            width: 40px;
                            height: 3px;
                            background: #FFFFFF;
                            border-radius: 2px;
                            float: left;
                            margin-top: -2px;
                            margin-left: 130px;
                        }
                    }

                    .header_gongye_lianjie_qiota {
                        float: left;
                        margin-left: 50px;
                        font-size: 18px;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                        margin-top: 8px;
                        //line-height: 100px;
                    }

                    .header_gongye_lianjie_qiota_xuanzhong {
                        font-size: 22px;
                        //font-weight: bold;
                        color: #4E6EF2;
                        margin-top: 4px;
                        //line-height: 100px;
                    }
                }
            }
        }

        .header_phone {
            background: #f4f4f4;
            color: #333333;
            line-height: 38px;
            font-size: 12px;
            padding-right: 15px;
            padding-left: 15px;
            font-family: Source Han Sans CN;
            font-weight: 600;

            .header_phone_name {
                float: left;
            }

            .head_phone_dingwei {
                float: left;
                width: 10px;
                margin-top: 12px;
                margin-left: 5px;
            }

            .head_phone_huanyi {
                float: left;
                margin-left: 12px;
            }

            .head_phone_xiaoxi_img {
                float: left;
                width: 18px;
                margin-top: 12px;
                margin-left: 20px;
            }

            .head_phone_xiaoxi {
                float: left;
                margin-left: 5px;
            }

            .head_phone_denglu {
                float: right;
                margin-right: 7px;
            }

            .head_phone_zhuce {
                float: right;
            }
        }

        .footer {
            width: 100%;
            height: 255px;
            background: #FFFFFF;
            border-bottom: #E1E1E1 solid 1px;

            .footer_width {
                width: 80%;
                max-width: 1200px;
                margin-right: auto;
                margin-left: auto;

                .xdsk_top {
                    position: relative;
                    margin-top: 70px;

                    .footer_img_xinshou {
                        //margin-left: 5px;
                        //margin-top: 13px;
                        position: absolute;
                        width: 50px;
                        height: 50px;
                    }

                    .footer_img_duiwai {
                        //margin-left: 155px;
                        //margin-top: 13px;
                        //margin-top: 13px;
                        position: absolute;
                        width: 50px;
                        height: 50px;
                    }

                    .footer_img_shiming {
                        //margin-left: 155px;
                        //margin-top: 13px;
                        position: absolute;
                        width: 50px;
                        height: 50px;
                    }

                    .footer_img_kefu {
                        //margin-left: 155px;
                        //margin-top: 13px;
                        position: absolute;
                        width: 50px;
                        height: 50px;
                    }

                    .footer_xinshou_left {
                        margin-left: 60px;
                    }

                    .footer_dsk_left {
                        margin-left: 60px;
                    }
                }

                .xdsk_bottom {
                    margin-top: 38px;

                    .footer_kongjian_left {
                        margin-left: 17px;
                    }

                    .footer_jiaoyi_left {
                        margin-left: 184px;
                    }

                    .footer_shiming_left {
                    }

                    .footer_tousu_left {
                        margin-left: 520px;
                    }

                    .footer_changjian_left {
                        margin-left: 945px;
                    }
                }

                .glzy_top {
                    margin-top: 51px;

                    .footer_gyyyj_left {
                        padding-right: 20px;
                        border-right: #E1E1E1 solid 1px;
                    }

                    .footer_lxwm_left {
                        margin-left: 29px;
                        padding-right: 21px;
                        border-right: #E1E1E1 solid 1px;
                    }
                }

                .glzy_bottom {
                    margin-top: 45px;
                }
            }
        }

        .footer_bottom {
            border-bottom: none;
            height: 223px;
        }
    }

    .youfudong {
        float: right;
    }

    .head_text {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #333333;
        line-height: 38px;
    }

    .footer_text1 {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 150;
        color: #666666;
        //line-height: 30px;
    }

    .footer_text2 {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        //line-height: 30px;
    }

    .footer_text3 {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #333333;
        //line-height: 30px;
    }

    .main_jinpai_text {
        //width: 78px;
        //height: 25px;
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #222222;
        line-height: 30px;
    }

    .main_jinpai_text2 {
        //width: 327px;
        //height: 50px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 350;
        color: #333333;
        line-height: 30px;
    }

    .xuanzhong:hover {
        //color:#4E6EF2;
        text-decoration: none;
    }

    .wenzi {
        text-decoration: none;
    }

    .lanmu:hover {
        background-color: #FF704D !important;
    }

    //a:hover {background-color:#FF704D;}
</style>
<style>
    .el-input__inner {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;

    }

    .el-input--suffix .el-input__inner {
        width: 133px;
        /*line-height: 60px;*/
        height: 27px;
        background: #E1E1E1;
        border-radius: 5px;

    }
</style>
<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

    @head_text: Source Han Sans CN;
    @font-face {

    }

    //@import "../../../assets/css/home";
    @import "../../../assets/css/home_case";
</style>
<style lang="less" scoped>
    @font-face {

    }
</style>
